import { useMutation, useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'
import {
  DataDownloadResponse,
  PlanningBookLedgerKeyFigure,
} from 'Features/DownloadDataModal/DownloadDataModal.types'

const fetchDashboardDownload = async ({
  planId,
  workcentreId,
  settings,
}: DataDownloadResponse) => {
  const { data } = await request({
    method: 'post',
    data: { settings },
    url: `plan/${planId}/workcentres/${workcentreId}/dashboard-download`,
  })
  return data
}

export const useDashboardDownload = (
  onSuccess: (data: any) => void,
  onError: () => void
) => {
  return useMutation(fetchDashboardDownload, {
    onSuccess: (data) => {
      onSuccess(data)
    },
    onError: () => {
      onError()
    },
  })
}

// R3: 200 on a plan with a PlanningBookLedger (the option is offered); 404
// LEDGER_NOT_AVAILABLE on a v1 plan (the option is absent).
export const usePlanningBookLedgerKeyFigures = (
  planId: string | undefined,
  workcentreId: string | undefined,
  enabled: boolean
) => {
  return useQuery(
    ['planning-book-ledger-key-figures', planId, workcentreId],
    async () => {
      const { data } = await request({
        url: `plan/${planId}/workcentres/${workcentreId}/planning-book-ledger-key-figures`,
      })
      return data
    },
    {
      select: (data): PlanningBookLedgerKeyFigure[] =>
        data?.data?.keyFigures ?? [],
      enabled,
      refetchOnWindowFocus: false,
    }
  )
}

// R4: csv comes back as the attachment, xlsx as {data, column_order}, as the
// DRP Outputs download. The modal's xlsx value is 'xlxs'; R4 takes 'xlsx'.
const fetchPlanningBookLedgerDownload = async ({
  planId,
  workcentreId,
  settings,
}: DataDownloadResponse) => {
  const { data } = await request({
    method: 'post',
    data: {
      settings: {
        fileVersion: settings.fileVersion,
        keyFigures: settings.keyFigures,
        fileFormat: settings.fileFormat === 'csv' ? 'csv' : 'xlsx',
      },
    },
    url: `plan/${planId}/workcentres/${workcentreId}/planning-book-ledger-download`,
  })
  return data
}

export const usePlanningBookLedgerDownload = (
  onSuccess: (data: any) => void,
  onError: () => void
) => {
  return useMutation(fetchPlanningBookLedgerDownload, {
    onSuccess: (data) => {
      onSuccess(data)
    },
    onError: () => {
      onError()
    },
  })
}
